import React from 'react';

import Images from '../Images';

const Header = () => {
	return (
		<div className={'ohs-header'}>
			<div className={'ohs-header__bar'}>
				<img className={'ohs-header__book'} src={Images.ohsPdf.book} alt='book' />
				<span className={'ohs-header__title'}>ORGANIZATIONAL HEALTH REPORT</span>
			</div>
		</div>
	);
};

export default Header;
